import {
	Skeleton,
	ErrorAlert,
	SkeletonProps,
} from '@montel/montelpro-shared-components-v2';
import { FunctionComponent } from 'react';
import { RequestStatus } from 'types/RequestStatus';

interface RequestSkeletonProps extends SkeletonProps {
	status: RequestStatus;
}

const RequestLoader: FunctionComponent<RequestSkeletonProps> = ({
	status,
	children,
	w,
	h,
	boxSize,
	className,
	speed,
	borderRadius,
	endColor,
	startColor,
	fadeDuration,
}) => {
	if (status === RequestStatus.SUCCESS) return <>{children}</>;

	if (status === RequestStatus.ERROR) {
		return (
			<ErrorAlert
				title="ERROR"
				text="An unexpected error was encountered. Please try again or contact a system administrator."
			/>
		);
	}

	if (status === RequestStatus.FORBIDDEN) {
		return (
			<ErrorAlert
				title="FORBIDDEN"
				text="You do not have access to the requested content."
			/>
		);
	}

	return (
		<Skeleton
			borderRadius={borderRadius}
			boxSize={boxSize}
			className={className}
			endColor={endColor}
			fadeDuration={fadeDuration}
			h={h ?? '100px'}
			speed={speed}
			startColor={startColor}
			w={w ?? '100%'}
		/>
	);
};

export default RequestLoader;
